import React from 'react';
import * as S from './style';
import {
  ContentsContainer,
  FormItem,
  SpaceDiv,
  BtnContainer,
} from 'components';
import FileImg, { Props as FileImgProps } from 'components/atoms/FileImg';
import BtnNext, { Props as BtnNextProps } from 'components/molecules/BtnNext';
import Introduce, {
  Props as IntroduceProps,
} from 'components/molecules/Introduce';

import {
  TITLE_DOC_REVIEW,
  LABEL_SERVICE_IMAGE,
  LABEL_BUSINESS_REGISTRATION_IMG,
  LABEL_FAMILY_RELATION_IMAGE,
  LABEL_LICENSE_IMG,
  LABEL_INDEMNITY_INSURANCE,
  LABEL_ARRANGE_LICENSE,
  LABEL_CAR_IMAGE,
} from 'commons/ZimssaString';

export interface Props {
  serviceImage?: FileImgProps;
  introduce?: IntroduceProps;
  businessRegistrationImage?: FileImgProps;
  familyRelationImage?: FileImgProps;
  transportationLicenseImage?: FileImgProps;
  indemnityInsuranceImage?: FileImgProps;
  arrangeLicenseImage?: FileImgProps;
  carImage?: FileImgProps;
  btnNext: BtnNextProps;
}

function DocReview({
  serviceImage,
  introduce,
  businessRegistrationImage,
  familyRelationImage,
  transportationLicenseImage,
  indemnityInsuranceImage,
  arrangeLicenseImage,
  carImage,
  btnNext,
}: Props): React.ReactElement {
  return (
    <S.DocReview>
      <ContentsContainer title={TITLE_DOC_REVIEW}>
        {serviceImage ? (
          <FormItem label={LABEL_SERVICE_IMAGE}>
            <FileImg {...serviceImage} />
          </FormItem>
        ) : null}
        {introduce ? <Introduce {...introduce} /> : null}
        {businessRegistrationImage ? (
          <FormItem label={LABEL_BUSINESS_REGISTRATION_IMG}>
            <FileImg {...businessRegistrationImage} />
          </FormItem>
        ) : null}
        {familyRelationImage ? (
          <FormItem label={LABEL_FAMILY_RELATION_IMAGE}>
            <FileImg {...familyRelationImage} />
          </FormItem>
        ) : null}
        {transportationLicenseImage ? (
          <FormItem label={LABEL_LICENSE_IMG}>
            <FileImg {...transportationLicenseImage} />
          </FormItem>
        ) : null}
        {indemnityInsuranceImage ? (
          <FormItem label={LABEL_INDEMNITY_INSURANCE}>
            <FileImg {...indemnityInsuranceImage} />
          </FormItem>
        ) : null}
        {arrangeLicenseImage ? (
          <FormItem label={LABEL_ARRANGE_LICENSE}>
            <FileImg {...arrangeLicenseImage} />
          </FormItem>
        ) : null}
        {carImage ? (
          <FormItem label={LABEL_CAR_IMAGE}>
            <FileImg {...carImage} />
          </FormItem>
        ) : null}
      </ContentsContainer>
      <SpaceDiv height={36} />
      <BtnContainer>
        <BtnNext {...btnNext} />
      </BtnContainer>
    </S.DocReview>
  );
}

export default DocReview;
